module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-background-proposal-2-12ec10aa5109fe84bbc317bdfd41ad6e.jpg";